<template>
  <div>    
      <h1>Pagina De Ayuda</h1>   
  </div>
</template>

<script>
import { eventBus } from '../../main';
export default {  
  data: function () {     
    return {
       
    }
  },
  mounted: function () {        
       
  },
  methods: {
    
  },
  filters: {
     
  },
  computed: {
    
  }
}
</script>

<style>
 
</style>



// WEBPACK FOOTER //
// Help.vue?a7b37df6